<!-- 报考信息  --  待考试的  查看详情 -->
<template>
  <div id="app">
    <div class="conent" v-for="(item, inde) in list" :key="inde">
      <div class="row">
        <div class="category">批次名称</div>
        <div class="categoryInfo">
          {{ item.appraisalBatchName }}
        </div>
      </div>
      <div class="row">
        <div class="category">考试科目</div>
        <div class="categoryInfo">
          {{ item.subject }}
        </div>
      </div>
      <div class="row">
        <div class="category">考试工种</div>
        <div class="categoryInfo">
          {{ item.examSubiectName }}
        </div>
      </div>
      <div class="row">
        <div class="category">考试等级</div>
        <div class="categoryInfo">
          {{ item.examRank }}
        </div>
      </div>
      <div class="row">
        <div class="category">报名时间</div>
        <div class="categoryInfo">
          {{ $moment(item.examDate).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
      </div>
      <div
        class="row"
        v-if="item.examAddressId !=''"
      >
        <div class="category">理论考试地点</div>
        <div class="categoryInfo">
          {{ item.examAddress }}
        </div>
      </div>
      <div class="row" v-if="item.liveAddressId !=''">
        <div class="category">实操考试地点</div>
        <div class="categoryInfo">
          {{ item.liveAddress }}
        </div>
      </div>
      <div class="row" v-if="item.examTime !=null">
        <div class="category">理论考试</div>
        <div class="categoryInfo">
          {{ item.examTime }}
        </div>
      </div>
      <div class="row" v-if="item.liveTime !=null">
        <div class="category">实操考试</div>
        <div class="categoryInfo">
          {{ item.liveTime }}
        </div>
      </div>
      <div class="row">
        <div class="category">状态</div>
        <div class="categoryInfo">
          {{ item.status }}
        </div>
      </div>
      <div>
        <!-- 更新证件照 -->
        <div class="filetext" style="margin:15px 0 8px 15px ;">更新证件照</div>
          <div  class="filetext3">
          <file-box style="margin-right:auto" @bindup="drag1" headert="证件照" :mainup="upname1"></file-box>
          <file-box-example
            headert="示例"
            imgName="personCard"
          ></file-box-example>
        </div>
       <input type="file" v-show="false" @change="input1change" ref="fileName1" />

      </div>
    </div>
  </div>
</template>

<script>
   import fileBox from "@/components/filebox.vue";
  import fileBoxExample from '@/view/reserve/fileUploadExample.vue'
  import { Dialog } from 'vant';
export default {
  components: {
    fileBoxExample,
    fileBox,
  },
  data() {
    return {
      upname1: "", //更新的证件照
      list: [],
      active: 0,
      statusObj: {
        unPay: "待支付",
        paid: "已支付",
        draft: "草稿",
        reject: "已驳回",
        unAppointment: "待预约",
        // 'unPay': '待支付',
        tested: "已考试",
        unTest: "未考试",
        toTest: "待考试",
        auditing: "审核中",
        examineePay: "考生交费",
        institutionPay: "机构交费",
      },
    };
  },
  created() {
    const params = {
      examOrderId: this.$route.query.examOrderId,
    };
    this.$http.post(`ExamOrder/Continue`, params).then((res) => {
      // console.log(res.data.data.list[0])
      this.list = res.data.data.list;
      this.upname1=res.data.data.list[0].examIdentificationImg
      //     this.list.forEach((element,index) => {
      //         element.statusText = this.statusObj[element.status]
      // })
    });
  },
  methods:{
    drag1() {
      this.$refs.fileName1[0].click()
    },
    input1change(event) {
      var formdata = new FormData();
      formdata.append("studentname", event.target.files[0]);
      this.$http.post(this.$server.upload, formdata).then((res) => {
        console.log(res);
        if (res.status == 200) {
          this.upname1 = res.data[0].path;
          const params={
            id:this.$route.query.examOrderId,
            examIdentificationImg:this.upname1
          }
          this.$http.put("ExamOrder/updateCertificate", params).then(
            (res)=>{
              if(res.data.success){
                Dialog.alert({
                  title: '提示',
                  message: res.data.msg,
                })
              }else{
                this.upname1 =""
                Dialog.alert({
                  title: '提示',
                  message: res.data.msg,
                })
              }
            }
          )
        }
      });
    },
  },
};
</script>

</script>

<style lang="less" scoped>
#app {
  background-color: #eee;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;
  width: 100%;
  height: 100vh;
  .conent {
    
    
    background: #ffffff;
    .filetext3{
    height: 300px;
    margin: 20px;
  display: flex;

  }
  }
}
#top {
  width: 100%;
  height: 70px;
  line-height: 70px;
  vertical-align: middle;
  /* padding-top: 40px; */
  background-color: rgba(245, 245, 245);
}
.rightcha {
  float: left;
}
.centerwz {
  /* display: block; */
  padding: 0px;
  font-size: 30px;
  line-height: 70px;
}

.centtree {
  height: 350px;
  background-color: #fff;
}
.row {
  width: 750px;
  height: 45px;
  display: flex;
  padding: 26px 0 0px 32px;
}
.category {
  width: 180px;
  height: 45px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #787878;
  line-height: 45px;
  margin: 0 20px 0 0;
}
.categoryInfo {
  width: 556px;
  height: 45px;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2f2f2f;
  line-height: 45px;
}
</style>